/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_mobile_analytics_app_id": "81f56bab935d4a299d892077deaef434",
    "aws_mobile_analytics_app_region": "us-east-1",
    "Analytics": {
        "AWSPinpoint": {
            "appId": "81f56bab935d4a299d892077deaef434",
            "region": "us-east-1"
        }
    },
    "Notifications": {
        "Push": {
            "AWSPinpoint": {
                "appId": "81f56bab935d4a299d892077deaef434",
                "region": "us-east-1"
            }
        },
        "InAppMessaging": {
            "AWSPinpoint": {
                "appId": "81f56bab935d4a299d892077deaef434",
                "region": "us-east-1"
            }
        }
    },
    "aws_cloud_logic_custom": [
        {
            "name": "shankapi",
            "endpoint": "https://ddvdhyxjpi.execute-api.us-east-1.amazonaws.com/prod",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:ceff112f-405f-4ede-a84d-7b34bf488509",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_WDuJ50oje",
    "aws_user_pools_web_client_id": "2h8lvfv1deeet20uo3cov5tg4c",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "shank-images225408-prod",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "shankdb-prod",
            "region": "us-east-1"
        }
    ]
};


export default awsmobile;
